export const
INCORRECT_COMPANY_TAX_FORMAT = `Niepoprawny format pola Nip!
                                Wartość powinna odpowiadać jednemu z następujących formatów:
                                * 0000000000
                                * 000-000-00-00
                                * 000-00-00-000`,
UNSELECTED_COMPANY = 'Należy wybrać firmę!';



// WEBPACK FOOTER //
// ./src/const/ErrorMessages/CompanyErrorMessages.js